import type { ReactNode } from 'react'
import { Alert, Button, Skeleton } from 'antd'
import { useCanManageMcp } from '../hooks'

type McpManageGateProps = { clientId: string; deniedMessage: string; children: ReactNode }

export default function McpManageGate({ clientId, deniedMessage, children }: McpManageGateProps) {
  const { status, error, retry } = useCanManageMcp(clientId)
  if (status === 'loading') return <Skeleton active paragraph={{ rows: 6 }} />
  if (status === 'error') {
    return (
      <Alert
        type="error"
        showIcon
        message={error instanceof Error ? error.message : 'Couldn’t check whether you manage this client.'}
        action={<Button onClick={retry}>Try again</Button>}
      />
    )
  }
  if (status === 'denied') return <Alert type="info" showIcon message={deniedMessage} />
  return <>{children}</>
}
